import { render, staticRenderFns } from "./CostBearersAppointments.vue?vue&type=template&id=b8ee7f60"
import script from "./CostBearersAppointments.vue?vue&type=script&lang=ts"
export * from "./CostBearersAppointments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports